import {CanActivate} from '@angular/router';
import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {catchError, filter, switchMap, take, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';

import {ApplicationState} from '../../application-state/store';
import {StorageSystemManufacturersActions} from '../store';
import {StorageSystemManufacturersSelectors} from '../store/selectors';

@Injectable()
export class StorageSystemManufacturersLoadedGuard implements CanActivate {

  constructor(private store: Store<ApplicationState>) {
  }

  canActivate(): Observable<boolean> {

    return this.loadStorageSystemManufacturersDone().pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
  }

  loadStorageSystemManufacturersDone() {

    return this.store.pipe(
      select(StorageSystemManufacturersSelectors.isLoaded),
      tap((loaded: boolean) => {
        if (!loaded) {
          this.store.dispatch(StorageSystemManufacturersActions.ReadStorageSystemManufacturers());
        }
      }),
      filter(loaded => loaded),
      take(1)
    );
  }
}
